import { gql } from '@apollo/client';

export * from './toggleIntegration.mutation.generated';

export const TOGGLE_INTEGRATION = gql`
  mutation toggleIntegration($integrationId: ID!) {
    toggleIntegration(input: { integrationId: $integrationId }) {
      success
      errors
      integration {
        id
        status
        active
      }
    }
  }
`;
